import React, { useState } from 'react';
import {Link,Outlet} from 'react-router-dom';
import IsMntnInqApi from 'Apis/IsMntnInqApi';
import { Accordion } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';

// css
import  'Assets/css/LoginMain.css';
import GlbFtrUi from 'Views/Glb/GlbFtrUi';


const LoginLayout = () => {
    // 모바일 가로모드 감지
    const [isLandscapeMobile, setIsLandscapeMobile] = useState(isMobile && window.innerWidth > window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setIsLandscapeMobile(isMobile && window.innerWidth > window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return (
        <>
        <div className='loginWrap'>
            <Link to="/" className='loginLayoutHomeBtn'>
                <img src={process.env.PUBLIC_URL + '/images/common/homeBtn.png'} alt="Logo"  style={{maxWidth:"30px",width:"100%"}}/>
            </Link>
            {isMobile ? (
                <video src="https://bb-cdn.onuniverse.io//web/login/bboLoginBgMo.mp4" autoPlay loop muted playsInline></video>
            ) : (
                <video src="https://bb-cdn.onuniverse.io//web/login/bboLoginBg.mp4" autoPlay loop muted playsInline></video>
            )}  
            <div className="loginContainer">
                <img src={process.env.PUBLIC_URL + '/images/BE@RBRICK-logo20251212.png'} alt="Logo"  style={{maxWidth:"300px",width:"100%",paddingBottom:"30px"}}/>
                <Outlet />
            </div>
        <GlbFtrUi gameSvcCd={"BBO"} gameMainPageData={null}/>
        </div>
        </>
    );
}
export default LoginLayout;